import React, { useState } from 'react'
import { useAuth } from '../contexts/AuthContext'
import { LoginCredentials } from '../types'

interface LoginFormProps {
  onClose: () => void
  onSwitchToRegister: () => void
}

export default function LoginForm({ onClose, onSwitchToRegister }: LoginFormProps) {
  const { login, isLoading } = useAuth()
  const [formData, setFormData] = useState<LoginCredentials>({
    username: '',
    password: ''
  })
  const [errors, setErrors] = useState<{ [key: string]: string }>({})

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }))
    }
  }

  const validateForm = (): boolean => {
    const newErrors: { [key: string]: string } = {}

    if (!formData.username.trim()) {
      newErrors.username = 'Username is required'
    }

    if (!formData.password) {
      newErrors.password = 'Password is required'
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    
    if (!validateForm()) {
      return
    }

    const success = await login(formData)
    if (success) {
      onClose()
    } else {
      setErrors({ submit: 'Invalid username or password' })
    }
  }

  return (
    <div className="auth-form-overlay">
      <div className="auth-form">
        <div className="auth-form-header">
          <h2>Log In</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit} className="auth-form-content">
          <div className="welcome-message">
            <p>Welcome back! Log in to write reviews and access your account.</p>
          </div>

          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleInputChange}
              className={errors.username ? 'error' : ''}
              placeholder="Enter your username"
              autoComplete="username"
            />
            {errors.username && <span className="error-message">{errors.username}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              className={errors.password ? 'error' : ''}
              placeholder="Enter your password"
              autoComplete="current-password"
            />
            {errors.password && <span className="error-message">{errors.password}</span>}
          </div>

          {errors.submit && (
            <div className="error-message submit-error">{errors.submit}</div>
          )}

          <div className="auth-form-actions">
            <button
              type="submit"
              className="submit-btn"
              disabled={isLoading}
            >
              {isLoading ? 'Logging in...' : 'Log In'}
            </button>
            
            <button
              type="button"
              className="switch-btn"
              onClick={onSwitchToRegister}
            >
              Don't have an account? Sign up
            </button>
          </div>

          <div className="demo-credentials">
            <h4>Need test credentials?</h4>
            <p>Contact the site administrator for login details</p>
            <button
              type="button"
              className="demo-btn"
              onClick={() => {
                setFormData({ username: 'demo', password: 'demo123' })
              }}
            >
              Use Demo Account
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}